/* Cosmopolitan landing page — rounds 4–10 additions (11 Sep 2026).
   Loaded after cosmo-lp.js. Three behaviours:
     1. smooth in-page scrolling for every CTA that targets the set builder;
     2. the set-builder product panel cross-fading with the colour choice;
     3. the compact set builder beside a shoppable video block. It reads the
        same [data-cosmo-config] JSON the main section prints, so variants,
        prices and stock have exactly one source of truth. */
(function () {
  'use strict';

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function dl(name, payload) {
    window.dataLayer = window.dataLayer || [];
    var obj = { event: name };
    if (payload) { for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) obj[k] = payload[k]; } }
    window.dataLayer.push(obj);
  }

  function config() {
    var node = document.querySelector('[data-cosmo-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function money(cfg, cents) {
    var n = cents / 100;
    return cfg.cur + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function pick(list, size, color) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].size === size && list[i].color === color) return list[i];
    }
    return null;
  }

  function values(list, key) {
    var out = [], seen = {};
    for (var i = 0; i < list.length; i++) {
      var v = list[i][key];
      if (v != null && !seen[v]) { seen[v] = 1; out.push(v); }
    }
    return out;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(items, onDone, onFail) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'add failed');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location.href = root() + 'cart';
        }
        if (onDone) onDone(data);
      })
      .catch(function (err) { if (onFail) onFail(err); });
  }

  /* ---------------- 1. smooth scroll ---------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('[data-cosmo-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    try {
      target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    } catch (err) {
      target.scrollIntoView();
    }
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', href);
    }
  });

  /* ---------------- 2. the product panel cross-fades with the colour -------
     The sets are stacked in one grid cell by the stylesheet, so both can be
     painted at once. The hidden attribute is dropped on boot — it is only
     there so the page degrades to one visible set without JavaScript — and
     visibility is carried by the .is-active class from then on. */

  function syncMedia(scope, color) {
    var wrap = scope.querySelector('[data-cosmo-media-wrap]');
    if (!wrap) return;
    var sets = wrap.querySelectorAll('[data-cosmo-media]');
    if (!sets.length) return;

    if (!wrap.dataset.crossfade) {
      wrap.dataset.crossfade = '1';
      wrap.classList.add('is-crossfade');
      Array.prototype.forEach.call(sets, function (n) { n.hidden = false; });
    }

    var matched = false;
    Array.prototype.forEach.call(sets, function (n) {
      var hit = n.getAttribute('data-cosmo-media') === color;
      n.classList.toggle('is-active', hit);
      n.setAttribute('aria-hidden', hit ? 'false' : 'true');
      if (hit) matched = true;
    });
    if (!matched) {
      sets[0].classList.add('is-active');
      sets[0].setAttribute('aria-hidden', 'false');
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    if (String(input.name).indexOf('cl-color-') !== 0) return;
    var scope = input.closest ? input.closest('[data-cosmo-root]') : null;
    if (!scope) return;
    syncMedia(scope, input.value);
  });

  /* ---------------- 3. the shoppable video builder ---------------- */

  var miniSeq = 0;

  function opts(name, list, checkFirst) {
    return list.map(function (v, i) {
      return '<label class="cs-mini__opt"><input type="radio" name="' + name + '" value="' +
        String(v).replace(/"/g, '&quot;') + '"' + (checkFirst && i === 0 ? ' checked' : '') +
        '><span>' + String(v).replace(/</g, '&lt;') + '</span></label>';
    }).join('');
  }

  function initMini(el, cfg) {
    if (el.dataset.miniReady === '1') return;
    el.dataset.miniReady = '1';

    var host = el.querySelector('[data-mini-controls]');
    var btn = el.querySelector('[data-mini-add]');
    var totalEl = el.querySelector('[data-mini-total]');
    var errEl = el.querySelector('[data-mini-error]');
    if (!host || !btn) return;

    var id = 'mini-' + (++miniSeq);
    var names = { color: id + '-color', bra: id + '-bra', thong: id + '-thong' };

    var colours = values(cfg.bra.variants, 'color');
    var braSizes = values(cfg.bra.variants, 'size');
    var thongSizes = values(cfg.thong.variants, 'size');

    host.innerHTML =
      '<fieldset><legend>Colour</legend><div class="cs-mini__opts">' + opts(names.color, colours, true) + '</div></fieldset>' +
      '<fieldset><legend>Bra size</legend><div class="cs-mini__opts">' + opts(names.bra, braSizes, false) + '</div></fieldset>' +
      '<fieldset><legend>Thong size</legend><div class="cs-mini__opts">' + opts(names.thong, thongSizes, false) + '</div></fieldset>';

    function checked(name) {
      var input = el.querySelector('input[name="' + name + '"]:checked');
      return input ? input.value : null;
    }

    function state() {
      var color = checked(names.color);
      var b = checked(names.bra);
      var t = checked(names.thong);
      return {
        color: color,
        bra: b ? pick(cfg.bra.variants, b, color) : null,
        thong: t ? pick(cfg.thong.variants, t, color) : null
      };
    }

    function render() {
      var s = state();
      Array.prototype.forEach.call(el.querySelectorAll('input[name="' + names.bra + '"]'), function (i) {
        var v = pick(cfg.bra.variants, i.value, s.color);
        i.disabled = !v || !v.available;
        if (i.disabled && i.checked) i.checked = false;
      });
      Array.prototype.forEach.call(el.querySelectorAll('input[name="' + names.thong + '"]'), function (i) {
        var v = pick(cfg.thong.variants, i.value, s.color);
        i.disabled = !v || !v.available;
        if (i.disabled && i.checked) i.checked = false;
      });

      var s2 = state();
      var braP = s2.bra ? s2.bra.price : (cfg.bra.variants[0] ? cfg.bra.variants[0].price : 0);
      var thongP = s2.thong ? s2.thong.price : (cfg.thong.variants[0] ? cfg.thong.variants[0].price : 0);
      var sum = braP + thongP;
      var fin = Math.round(sum * (100 - cfg.pct) / 100);

      if (totalEl) {
        totalEl.innerHTML = 'The set <s>' + money(cfg, sum) + '</s> <strong>' + money(cfg, fin) +
          '</strong> with ' + cfg.code;
      }
      btn.disabled = !(s2.bra && s2.thong);
    }

    var touched = false;
    el.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[type="radio"]')) return;
      if (!touched) {
        touched = true;
        dl('cosmo_builder_engaged', { cosmo_first_choice: 'video' });
      }
      render();
    });

    btn.addEventListener('click', function () {
      var s = state();
      if (!s.bra || !s.thong) return;
      var original = btn.textContent;
      var done = btn.getAttribute('data-mini-added') || 'Added';
      btn.disabled = true;
      if (errEl) errEl.hidden = true;

      addToCart(
        [{ id: s.bra.id, quantity: 1 }, { id: s.thong.id, quantity: 1 }],
        function () {
          dl('cosmo_set_added', {
            cosmo_source: 'video',
            cosmo_colour: s.color,
            cosmo_bra_size: s.bra.size,
            cosmo_thong_size: s.thong.size,
            value: (s.bra.price + s.thong.price) / 100,
            currency: 'EUR'
          });
          btn.textContent = done;
          window.setTimeout(function () { btn.textContent = original; render(); }, 2500);
        },
        function (err) {
          if (errEl) {
            errEl.textContent = cfg.errorText || 'Something went wrong. Please try again.';
            errEl.hidden = false;
          }
          dl('cosmo_set_add_failed', { cosmo_source: 'video', cosmo_error: String(err && err.message ? err.message : err) });
          render();
        }
      );
    });

    render();
  }

  /* ---------------- boot ---------------- */

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-root]'), function (scope) {
      var c = scope.querySelector('input[name^="cl-color-"]:checked');
      if (c) syncMedia(scope, c.value);
    });

    var cfg = config();
    if (!cfg || !cfg.bra || !cfg.thong) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-mini]'), function (el) {
      initMini(el, cfg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-mini]'), function (el) {
      el.dataset.miniReady = '';
    });
    boot();
  });
})();
